export default __webpack_public_path__ + "e681a4e.png";